import React from 'react'
import styles from '../Components/CertificationsEachWrapper.module.css'
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";

const CertificationsEachWrapper = props => {
    const { item } = props

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.leftCol}>
                <div className={styles.dateWrapper}>
                    <div className={styles.upperDate}>
                        <div className={styles.month}>
                            {item?.end_date?.substring(5, 7)}
                        </div>
                        <div className={styles.year}>
                            {item?.end_date?.substring(0, 4)}
                        </div>
                    </div>
                    <div className={styles.lowerDate}>
                        <div>{item?.duration}</div>
                    </div>
                </div>
            </div>
            <div className={styles.rightCol}>
                <div className={styles.rightContainer}>
                    <div className={styles.title}>
                        {item?.course_title}
                    </div>
                    <div>
                        <div>{item?.course_academy}</div>
                        <div className={styles.academy_address}>{item?.academy_address}</div>
                    </div>
                    <div className={styles.description}>
                        <RiDoubleQuotesL />
                        {item?.description}
                        <RiDoubleQuotesR />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CertificationsEachWrapper